import { render, staticRenderFns } from "./entrustSettlement.vue?vue&type=template&id=b6c725b4&scoped=true"
import script from "./entrustSettlement.vue?vue&type=script&lang=js"
export * from "./entrustSettlement.vue?vue&type=script&lang=js"
import style0 from "./entrustSettlement.vue?vue&type=style&index=0&id=b6c725b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c725b4",
  null
  
)

export default component.exports